<template>
  <div>
    <box>
      <div slot="body">
        <section class="content text-center h2 font-weight-bold">
          Usuários ficam no novo front-end! Abrirá em nova aba...
        </section>
      </div>
    </box>
  </div>
</template>

<script>
import Box from '../../components/Box.vue'
import configs from '../../configs'

export default {
  name: 'usuario-form',
  data() {
    return {}
  },
  mounted() {
    this.openNewNcm()
  },
  methods: {
    openNewNcm() {
      const environment = configs.API_NCM_IP.includes('stg') ? '.stg' : ''
      setTimeout(() => {
        this.$router.push({ name: 'Main' })
        window.open(`https://next${environment}.ncmhelper.com.br/#/users`, '_blank')
      }, 500)
    }
  },
  components: {
    Box
  }
}
</script>

<style lang="css">
.number::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
